import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Vendor() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Vendor Management and Pricing</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/vender.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Optimize your supply chain through proactive vendor management and intelligent pricing strategies designed to maximize profitability and operational efficiency.</p>
                        <h2 style={{fontWeight:'bold'}}>Our Approach</h2>
                        <p>
                            <ul>
                                <li><b>Supplier identification & qualification of trusted vendors meeting your standard</b> <br /><br/></li>
                                <li><b>Contract negotiation & renewal for optimal pricing and terms</b> <br /><br/></li>
                                <li><b>Vendor performance monitoring to ensure quality and reliability</b> <br /><br/></li>
                                <li><b>Risk assessment and contingency planning</b> <br/><br/></li>
                                <li><b>Price benchmarking with market data for competitive pricing</b></li>
                            </ul>
                            
                            
                            
                            
                            
                        </p>
                        {/* <h3 style={{fontWeight:'bold'}}>How It Improves Your Business</h3>
                        <div className="row vendor-benefits" >
                            <Row>
                                {[
                                    {
                                        id: "01.",
                                        title: "Cost Efficiency",
                                        description: "You can lower procurement costs, boost profit margins, and strengthen your company's financial standing by refining vendor relationships and pricing strategies.",
                                        icon: "fa-solid fa-dollar-sign",
                                    },
                                    {
                                        id: "02.",
                                        title: "Improved Quality and Reliability",
                                        description: "Selecting the appropriate suppliers guarantees top-notch goods and services that satisfy your company's requirements, which eventually improves your standing and client pleasure.",
                                        icon: "fa-solid fa-star",
                                    },
                                    {
                                        id: "03.",
                                        title: "Streamlined Operations",
                                        description: "Better supply chain operations, fewer delays, and lower risks are all made possible by effective vendor management, which also makes corporate procedures go more smoothly and increases overall efficiency. ",
                                        icon: "fa-solid fa-stopwatch",
                                    },
                                    {
                                        id: "04.",
                                        title: "Scalable Growth",
                                        description: "We make sure that your pricing structures and vendor network are flexible and scalable as your company grows, enabling you to scale operations without sacrificing quality or cost.",
                                        icon: "fa-solid fa-chart-line",
                                    },
                                ].map((card, index) => (
                                    <Col sm={12} md={12} lg={6} className="mb-4" key={index}>
                                        <div className="vendor-benefit-card text-center p-4" style={{height:'100%'}}>
                                           
                                            <h4 className="mb-2 vendor-card-titleicon">
                                                <span> <i
                                                className={`${card.icon} fa-xl mb-3`}
                                                style={{ color: "#b80404" }}
                                            ></i></span>
                                                {card.title}</h4>
                                            <p className="text-muted" style={{textAlign:'left'}}>{card.description}</p>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>*/}
                    </div> 

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{fontWeight:'bold'}}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Minimized supply disruptions</li>
                                <li><span class="arrow">➤</span>Improved cash flow</li>
                                <li><span class="arrow">➤</span>Consistent product quality</li>
                                <li><span class="arrow">➤</span>Strong vendor partnerships</li>
                                <li><span class="arrow">➤</span>Scalable procurement</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/vendorv.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />
                            
                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
